import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-government-detail',
  templateUrl: './government-detail.component.html',
  styleUrls: ['./government-detail.component.sass']
})
export class GovernmentDetailComponent implements OnInit {
  docId;
  item;
  coverPicture: string = "./assets/img/no-cover.png";
  profilePicture: string = "./assets/img/no-logo.png";
  //email: string = 'moses@pngl.com';
  showFullText = false;

  constructor(
    public db: FirestoreService,
    public route: Router,
    public aroute: ActivatedRoute
    ) {
      this.ngOnInit();
    }

  ngOnInit(): void {
    this.docId = this.aroute.snapshot.paramMap.get('id')
    this.item = this.db.getGovernmentDetails(this.docId)  
    
    this.route.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });
    
  }
  
  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
  }

   toggleShowFullText() {
    this.showFullText = !this.showFullText;
  }

  routeToPeopleDetailsUpdatePage(){
    this.route.navigate(['people/update/details']);
  }


}